/** @format */
import angular from 'angular';
import { IconComponent } from '../../icon/icon.component';
import { PopoverComponent } from '../../popover/popover.component';
import { searchComponentUtilsServiceModule } from '../searchComponentUtils.service';
import { searchFilterModule } from './searchFilter.component';
import searchFilterTpl from './searchFilterTag.tpl.html';

export const searchFilterTagModule = 'sis-components.search.searchFilterTag';

angular
    .module(searchFilterTagModule, [
        searchComponentUtilsServiceModule,
        searchFilterModule,
        IconComponent.downgrade.moduleName,
        PopoverComponent.downgrade.moduleName,
    ])
    .component('searchFilterTag', {
        bindings: {
            onSelect: '&',
            option: '<',
            parameterModel: '<',
            removeSelection: '&?',
            // Necessary only if searchFilterType is 'Education', 'Organisation' or 'OrganisationRoots'
            searchAgain: '&?',
            searchParameter: '<',
            // Necessary only if searchFilterType is 'Education', 'Organisation' or 'OrganisationRoots'
            searchParams: '<?',
            university: '<',
            isPermanent: '<?',
        },
        template: searchFilterTpl,
        controller: [
            '$timeout',
            'searchComponentUtilsService',
            function ($timeout, searchComponentUtilsService) {
                const ctrl = this;

                ctrl.popoverIsOpen = false;

                ctrl.getParameterValue = () => searchComponentUtilsService.getDisplayValueString(ctrl.parameterModel);

                ctrl.submitFilter = (values, searchParameter) => {
                    ctrl.onSelect(values, searchParameter);
                    ctrl.onHidden();
                };

                ctrl.onHidden = () => {
                    $timeout(() => {
                        ctrl.popoverIsOpen = false;
                    });
                };

                ctrl.onShown = () => {
                    $timeout(() => {
                        ctrl.popoverIsOpen = true;
                    });
                };

                ctrl.isPopoverDisabled = searchParameter => {
                    return searchParameter === 'searchString';
                };
            },
        ],
    });
